"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERNAL_PROTOCOL = void 0;
exports.INTERNAL_PROTOCOL = 'shopify:';